import { Injectable } from '@angular/core';
import { ZonaModel } from '../models/zona.model';
import { BDT_RECURSOS, BdtService } from '../../bdt/bdt.service';
import { BdtRecursoModel } from '../../bdt/models/bdt-recurso.model';
import { Herramientas, HerramientasText } from 'src/app/components/zones/zones.component';
import { AppComponent } from 'src/app/app.component';

export type ZonaList = ZonaModel & {
  TipoZona: string,
  Herramienta: string,
};

@Injectable({
  providedIn: 'root'
})
export class ZonesTransformerService {
  private tipos: BdtRecursoModel[] = [];

  public constructor(private bdtService: BdtService) {
    this.getTipos();
  }

  private async getTipos(): Promise<void> {
    this.tipos = await this.bdtService.getRecursos(BDT_RECURSOS.Edificios);
  }

  public transformZonaApiToList(zona: ZonaModel): ZonaList {
    const tipoZona = this.tipos.find(t => t.Id === zona.TipoBDT).Nombre || this.tipos.find(t => t.Id === 0).Nombre;
    const herramienta = AppComponent.translate(HerramientasText[Herramientas[zona.Tipo]]);

    return {
      ...zona,
      TipoZona: tipoZona,
      Herramienta: herramienta
    }
  }
}
